/* Review carousel.
   Touch and pen are left entirely to the browser's native scrolling — nothing
   imitated in JS feels as smooth. This file adds only what native scrolling lacks
   on desktop: dragging with the mouse (with inertia and a snap to the nearest card),
   the arrow buttons, and scrolling to a card when it's selected in the theme editor. */
(function () {
  /* The hero's Reviews phase loads this file too: run once per page. */
  if (window.HBReviewsCarousel) return;
  window.HBReviewsCarousel = true;
  var instances = new WeakMap();

  function mount(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-rc-track]');
    if (!track) return;

    /* Hand-placed tilt and lift, by real order (every card leans differently from
       its neighbours). CSS position rules can't do this reliably: wrappers or hidden
       elements between cards make every card count the same. */
    var K = [-1, 0.7, -0.45, 1, -0.7, 0.45], OY = [0, -1, 0.7, -0.4, 1, -0.6];
    function tilt() {
      track.querySelectorAll('[data-rc-card]').forEach(function (c, i) {
        c.style.setProperty('--k', K[i % 6]);
        c.style.setProperty('--oy', OY[i % 6]);
      });
    }
    tilt();
    /* Theme editor: cards added or reordered refresh on their own, so re-tilt. */
    var mo = null;
    if (window.Shopify && window.Shopify.designMode && window.MutationObserver) {
      mo = new MutationObserver(tilt);
      mo.observe(track, { childList: true, subtree: true });
    }

    /* In the home hero the cards are a grid, not a strip: keep the tilt, but no mouse
       drag (it would block text selection and swallow clicks), no arrows, no snapping. */
    if (root.closest('[data-hfs-reviews]')) {
      instances.set(root, { destroy: function () { if (mo) mo.disconnect(); } });
      return;
    }

    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cleanups = [];
    var down = false, moved = false, pid = null;
    var startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0, raf = 0;

    function on(el, ev, fn, opts) {
      if (!el) return;
      el.addEventListener(ev, fn, opts);
      cleanups.push(function () { el.removeEventListener(ev, fn, opts); });
    }

    function maxLeft() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function clamp(x) { return Math.min(maxLeft(), Math.max(0, x)); }

    /* Scroll position at which each card lines up with the header. */
    function stops() {
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var cards = track.querySelectorAll('[data-rc-card]');
      var out = [];
      for (var i = 0; i < cards.length; i++) out.push(clamp(cards[i].offsetLeft - pad));
      return out;
    }

    function glide(x) {
      track.scrollTo({ left: clamp(x), behavior: reduce ? 'auto' : 'smooth' });
    }

    function snapNearest() {
      var s = stops(), x = track.scrollLeft, best = x, d = Infinity;
      for (var i = 0; i < s.length; i++) {
        if (Math.abs(s[i] - x) < d) { d = Math.abs(s[i] - x); best = s[i]; }
      }
      glide(best);
    }

    function stopInertia() {
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }

    /* ---- mouse drag ---- */
    on(track, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      stopInertia();
      down = true;
      moved = false;
      pid = e.pointerId;
      startX = lastX = e.clientX;
      startLeft = track.scrollLeft;
      lastT = performance.now();
      vel = 0;
      /* No pointer capture yet: a plain click must still reach the card (and the
         theme editor's block selection). Capture starts once the mouse drags. */
    });

    on(track, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        try { track.setPointerCapture(pid); } catch (_) {}
        track.classList.add('is-dragging');
      }
      if (!moved) return;
      track.scrollLeft = startLeft - dx;
      var now = performance.now();
      var dt = now - lastT;
      if (dt > 0) vel = (e.clientX - lastX) / dt; /* px per ms */
      lastX = e.clientX;
      lastT = now;
    });

    function release() {
      if (!down) return;
      down = false;
      try { track.releasePointerCapture(pid); } catch (_) {}
      if (!moved) return; /* a plain click: leave the position alone */
      track.classList.remove('is-dragging');
      /* A drag that stopped moving before release carries no momentum. */
      if (performance.now() - lastT > 80) vel = 0;
      if (reduce || Math.abs(vel) < 0.05) { snapNearest(); return; }
      var v = -vel * 16; /* px per frame */
      (function step() {
        v *= 0.93;
        track.scrollLeft += v;
        var atEdge = track.scrollLeft <= 0 || track.scrollLeft >= maxLeft();
        if (Math.abs(v) < 0.6 || atEdge) { raf = 0; snapNearest(); return; }
        raf = requestAnimationFrame(step);
      })();
    }
    on(track, 'pointerup', release);
    on(track, 'pointercancel', release);
    /* Without early capture, a button released outside the track must still end the drag. */
    on(window, 'pointerup', release);

    /* A drag must not also count as a click, and images must not ghost-drag. */
    on(track, 'click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    on(track, 'dragstart', function (e) { e.preventDefault(); });

    /* Any other scrolling (trackpad, keyboard, arrows) cancels a running glide. */
    on(track, 'wheel', stopInertia, { passive: true });

    /* ---- arrow buttons ---- */
    function go(dir) {
      stopInertia();
      var s = stops(), x = track.scrollLeft, t, i;
      if (dir > 0) {
        for (i = 0; i < s.length; i++) if (s[i] > x + 4) { t = s[i]; break; }
        if (t === undefined) t = maxLeft();
      } else {
        for (i = s.length - 1; i >= 0; i--) if (s[i] < x - 4) { t = s[i]; break; }
        if (t === undefined) t = 0;
      }
      glide(t);
    }
    on(prev, 'click', function () { go(-1); });
    on(next, 'click', function () { go(1); });

    var queued = false;
    function update() {
      queued = false;
      var m = maxLeft();
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= m - 2;
    }
    function onScroll() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    on(track, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });

    /* ---- theme editor: selecting a card in the sidebar scrolls it into view ---- */
    on(document, 'shopify:block:select', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-rc-card]') : null;
      if (!card || !track.contains(card)) return;
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      glide(card.offsetLeft - pad);
    });

    /* Ready: unlocks the grab cursor, hidden scrollbar and arrows in the CSS.
       Without JS the visitor keeps the native scrollbar instead. */
    root.setAttribute('data-rc-ready', '');
    update();

    instances.set(root, {
      destroy: function () {
        stopInertia();
        cleanups.forEach(function (fn) { fn(); });
        if (mo) mo.disconnect();
      }
    });
  }

  function unmount(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.destroy();
    instances.delete(root);
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-rc]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  } else {
    mountAll();
  }
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rc]').forEach(unmount);
  });
})();
